module.exports = __webpack_public_path__ + "5585fcfd6469764bce567fd1aaa9b787.MP3";